import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';

// Dev-only Service Health views inside the Adoption Signals workspace.
// Descriptors declare the UI contract only; data and transforms live in
// useServiceHealthData.js and serviceHealthViewModel.js.

export const SERVICE_HEALTH_VIEW_ID = 'service-health';
export const SERVICE_HEALTH_LABEL = 'Service Health';

const MATRIX_SKELETON = {
  kind: 'chart',
  preset: 'barTrend',
  variant: 'bar',
  height: '42vh',
  width: '100%',
  minHeight: 320,
};

const TREND_SKELETON = {
  kind: 'chart',
  preset: 'trendLine',
  variant: 'line',
  height: '38vh',
  width: '100%',
  minHeight: 280,
};

const TABLE_SKELETON = {
  kind: 'table',
  preset: 'signal',
  rows: 12,
  columns: 9,
  tableWidth: '100%',
  height: 320,
};

export const marketServiceHealthView = () => ({
  id: SERVICE_HEALTH_VIEW_ID,
  label: SERVICE_HEALTH_LABEL,
  description: 'Vendors reporting disruption and demand-driven incidents across the market',
  icon: MonitorHeartOutlinedIcon,
  requiredData: 'serviceHealth',
  controls: ['category', 'ownership', 'days', 'viewMode'],
  layout: 'chartTable',
  panels: [
    { id: 'outageMatrix', kind: 'chart', skeleton: MATRIX_SKELETON },
    { id: 'disruptionScreener', kind: 'table', skeleton: TABLE_SKELETON },
  ],
  visualizations: ['heatmap', 'stackedBar', 'table'],
  tableColumns: ['company', 'category', 'date', 'metricValue', 'trendDelta', 'link'],
});

export const companyServiceHealthView = () => ({
  id: SERVICE_HEALTH_VIEW_ID,
  label: SERVICE_HEALTH_LABEL,
  description: 'Reported service health by status page, product, component, and region',
  icon: MonitorHeartOutlinedIcon,
  requiredData: 'serviceHealth',
  controls: ['companySearch', 'series', 'days', 'viewMode'],
  layout: 'chartTable',
  panels: [
    { id: 'scopeHealthTrend', kind: 'chart', skeleton: TREND_SKELETON },
    { id: 'scopeIncidents', kind: 'table', skeleton: TABLE_SKELETON },
  ],
  visualizations: ['kpiStrip', 'trendLine', 'table'],
  tableColumns: ['title', 'region', 'date', 'metricValue', 'category', 'link'],
});
